import React, { useState, useEffect } from 'react';
import CustomTitle from '../../components/UI/title/CustomTitle';
import './price9.scss'
import { Helmet } from 'react-helmet';
import PriceInfo from '../../components/PriceInfo/PriceInfo';
import MyButton from '../../components/UI/button/MyButton';
import { useHistory } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import useBlockClassName from '../../hooks/useBlockClassName';

const Price9 = ({ setShowTermBundle, setButtonText, setButtonShow, setPriceBottomShow, setWhiteWrapper, setEventProperties, sessionId, setEventName }) => {
    const { updateBlockClassName } = useBlockClassName();

    const history = useHistory();
    useEffect(() => {
        updateBlockClassName("block-price9")
        setButtonShow(false);
        if (setWhiteWrapper) {
            setWhiteWrapper(true)
        }
        // setEventName('web_price')
        // setEventProperties({
        //     web_entrance: localStorage.getItem('signupMethod') === "Login" ? 'login' : 'signup',
        //     session_id: sessionId,
        //     user_id: localStorage.getItem('userId')
        // })
        setPriceBottomShow(false);
        // localStorage.setItem("price", 'plus')
        // localStorage.setItem("plan", '4-Week Plan')
        localStorage.setItem("price", 1)
        const setVHVariable = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        setVHVariable();
        window.addEventListener('resize', setVHVariable);
        return () => window.removeEventListener('resize', setVHVariable);
    }, []);

    const [activePlan, setActivePlan] = useState(1);
    const [activePrice, setActivePrice] = useState('$29.95');
    const [activeOldPrice, setActiveOldPrice] = useState('$83.00');

    const plans = [
        {
            id: 0,
            name: '2 weeks ',
            price: '$19.95',
            oldPrice: '$42.00',
            priceDay: '$1.42 per day',
            sale: 'Best for newbies',
            week: '2 weeks',
            features: [
                {
                    text: 'Launch up to 50 campaigns',
                    status: true
                },
                {
                    text: 'Build up to 100 creatives',
                    status: true
                },
                {
                    text: 'Create up to 10 AI avatar videos',
                    status: true
                },
                {
                    text: 'Add unlimited products',
                    status: true
                },
                {
                    text: 'Integrate Paypal & Stripe',
                    status: true
                },
                {
                    text: 'Get 24/7 support anytime you need it',
                    status: true
                },
            ]
        },
        {
            id: 1,
            name: '1 month',
            price: '$29.95',
            oldPrice: '$83.00',
            // activeTrial: 'Most Popular',
            priceDay: '$1.00 per day',
            sale: 'Most popular',
            week: 'first month',
            features: [
                {
                    text: 'Launch up to 100 campaigns',
                    status: true
                },
                {
                    text: 'Build up to 250 creatives',
                    status: true
                },
                {
                    text: 'Create up to 20 AI avatar videos',
                    status: true
                },
                {
                    text: 'Add unlimited products',
                    status: true
                },
                {
                    text: 'Integrate Paypal & Stripe',
                    status: true
                },
                {
                    text: 'Get 24/7 support anytime you need it',
                    status: true
                },
            ]
        },
        {
            id: 2,
            name: '2 months',
            price: '$49.95',
            oldPrice: '$167.00',
            priceDay: '$0.86 per day',
            sale: 'Best price',
            week: '2 months',
            features: [
                {
                    text: 'Launch up to 150 campaigns',
                    status: true
                },
                {
                    text: 'Build up to 500 creatives',
                    status: true
                },
                {
                    text: 'Create up to 30 AI avatar videos',
                    status: true
                },
                {
                    text: 'Add unlimited products',
                    status: true
                },
                {
                    text: 'Integrate Paypal & Stripe',
                    status: true
                },
                {
                    text: 'Get 24/7 support anytime you need it',
                    status: true
                },
            ]
        },
    ];

    const handlePlanClick = (planId, planName, planPrice, planOldPrice) => {
        setActivePlan(planId);
        localStorage.setItem("price", planId)
        localStorage.setItem("plan", planName)
        setActivePrice(planPrice)
        setActiveOldPrice(planOldPrice)
    };

    const [time, setTime] = useState(15 * 60);

    useEffect(() => {
        if (time > 0) {
            const timerId = setInterval(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);

            return () => clearInterval(timerId);
        } else {
            history.push('/');
        }
    }, [time]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    };

    return (
        <div>



            <div className="price9">
                <div className="price9-timer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 3.98787C9.71667 3.98787 9.47917 3.89259 9.2875 3.70204C9.09583 3.51149 9 3.27537 9 2.99369C9 2.71201 9.09583 2.47589 9.2875 2.28534C9.47917 2.09479 9.71667 1.99951 10 1.99951H14C14.2833 1.99951 14.5208 2.09479 14.7125 2.28534C14.9042 2.47589 15 2.71201 15 2.99369C15 3.27537 14.9042 3.51149 14.7125 3.70204C14.5208 3.89259 14.2833 3.98787 14 3.98787H10ZM12 14.9238C12.2833 14.9238 12.5208 14.8285 12.7125 14.638C12.9042 14.4474 13 14.2113 13 13.9296V9.95293C13 9.67125 12.9042 9.43513 12.7125 9.24458C12.5208 9.05403 12.2833 8.95876 12 8.95876C11.7167 8.95876 11.4792 9.05403 11.2875 9.24458C11.0958 9.43513 11 9.67125 11 9.95293V13.9296C11 14.2113 11.0958 14.4474 11.2875 14.638C11.4792 14.8285 11.7167 14.9238 12 14.9238ZM12 22.8772C10.7667 22.8772 9.60417 22.6411 8.5125 22.1689C7.42083 21.6967 6.46667 21.0546 5.65 20.2427C4.83333 19.4308 4.1875 18.4821 3.7125 17.3968C3.2375 16.3115 3 15.1558 3 13.9296C3 12.7035 3.2375 11.5478 3.7125 10.4624C4.1875 9.37714 4.83333 8.42853 5.65 7.61662C6.46667 6.8047 7.42083 6.16263 8.5125 5.6904C9.60417 5.21816 10.7667 4.98204 12 4.98204C13.0333 4.98204 14.025 5.14774 14.975 5.47913C15.925 5.81053 16.8167 6.29105 17.65 6.92069L18.35 6.22477C18.5333 6.0425 18.7667 5.95137 19.05 5.95137C19.3333 5.95137 19.5667 6.0425 19.75 6.22477C19.9333 6.40703 20.025 6.63901 20.025 6.92069C20.025 7.20238 19.9333 7.43435 19.75 7.61662L19.05 8.31254C19.6833 9.14102 20.1667 10.0275 20.5 10.972C20.8333 11.9164 21 12.9023 21 13.9296C21 15.1558 20.7625 16.3115 20.2875 17.3968C19.8125 18.4821 19.1667 19.4308 18.35 20.2427C17.5333 21.0546 16.5792 21.6967 15.4875 22.1689C14.3958 22.6411 13.2333 22.8772 12 22.8772ZM12 20.8889C13.9333 20.8889 15.5833 20.2095 16.95 18.8508C18.3167 17.4921 19 15.8517 19 13.9296C19 12.0076 18.3167 10.3672 16.95 9.00846C15.5833 7.64976 13.9333 6.9704 12 6.9704C10.0667 6.9704 8.41667 7.64976 7.05 9.00846C5.68333 10.3672 5 12.0076 5 13.9296C5 15.8517 5.68333 17.4921 7.05 18.8508C8.41667 20.2095 10.0667 20.8889 12 20.8889Z" fill="#5BF0A5" />
                    </svg>
                    <span>{formatTime(time)}</span>
                </div>
                <CustomTitle style={{ marginBottom: "24rem" }} title="Choose your plan with<br>up to 70% discount" />
                <div>
                    {plans.map((plan) => (
                        <div
                            key={plan.id}
                            className={`price-plans__plan ${activePlan === plan.id ? 'price-plans__plan--active' : ''}`}
                            onClick={() => handlePlanClick(plan.id, plan.name, plan.price, plan.oldPrice)}
                        >
                            {plan.activeTrial &&
                                <div className="price-plans__plan-active-trial">{plan.activeTrial}</div>}
                            <div className="price-plans__top">

                                <div className="price-plans__top-info">
                                    <h2 className="price-plans__plan-title">{plan.name}


                                        <i>{plan.sale}</i>

                                    </h2>

                                    <div className="price-plans__plan-day">After {plan.week}: $79.95/month</div>

                                </div>
                                <p className="price-plans__plan-price">



                                    {plan.price}
                                    <span>{plan.oldPrice}</span>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <div style={{ position: 'relative', margin: '18rem auto 14rem', display: 'flex', justifyContent: 'center' }}>
                    <PriceInfo sessionId={sessionId} eventName={'web_click_pricepricing'} setShowTermBundle={setShowTermBundle} text="After the offer ends, you’ll switch to regular pricing" />
                </div>

                <MyButton
                    // ref={nextPageButtonRef}
                    buttonStatus={''}
                    buttonTime={150}
                    buttonText={`Get my plan`}
                    onClick={() => {
                        mixpanel.track('web_price', {
                            session_id: sessionId,
                            web_entrance: localStorage.getItem('signupMethod') === "Login" ? 'login' : 'signup',
                            user_id: localStorage.getItem('userId'),
                            // web_pay_method: 'CreditCard',
                            web_utm_campaign: localStorage.getItem("utmCampaign"),
                            web_utm_source: localStorage.getItem("utmSource"),
                            web_utm_medium: localStorage.getItem("utmMedium"),
                            web_utm_content: localStorage.getItem("utmContent"),
                            web_utm_term: localStorage.getItem("utmTerm"),
                            isDebug: false,
                            funnel: 'MAIN_v1',
                        });
                        history.push('/trial');
                    }}


                >
                </MyButton>

                <div className="price-cancel">
                    {/* <div className="price-cancel-item">
                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.02869 1.53255C9.8311 0.696643 11.1689 0.696642 11.9713 1.53255C12.4705 2.05255 13.2075 2.2703 13.9091 2.1047C15.0311 1.83984 16.1528 2.57657 16.3783 3.70716C16.5197 4.41581 17.024 5.00876 17.7041 5.25309C18.793 5.6443 19.3409 6.8693 18.9237 7.94854C18.6623 8.62455 18.7703 9.39791 19.2107 9.97357C19.9165 10.8963 19.7296 12.2233 18.7923 12.9098C18.2084 13.3375 17.8907 14.0498 17.9528 14.771C18.0517 15.9205 17.1832 16.9445 16.0313 17.0098C15.311 17.0507 14.6624 17.4734 14.3291 18.1133C13.7956 19.1374 12.5122 19.5228 11.5099 18.9495C10.8842 18.5916 10.1158 18.5916 9.49013 18.9495C8.48778 19.5228 7.20441 19.1374 6.67092 18.1133C6.33759 17.4734 5.68904 17.0507 4.96872 17.0098C3.81683 16.9445 2.94827 15.9205 3.04721 14.771C3.10927 14.0498 2.79163 13.3375 2.20767 12.9098C1.27036 12.2233 1.08345 10.8963 1.78932 9.97357C2.22966 9.39791 2.33766 8.62455 2.07634 7.94854C1.65913 6.8693 2.20698 5.6443 3.29591 5.25309C3.97596 5.00876 4.48031 4.41581 4.62167 3.70716C4.8472 2.57657 5.96891 1.83984 7.09095 2.1047C7.79247 2.2703 8.52953 2.05255 9.02869 1.53255Z" fill="black" />
                            <path d="M7 9.99982L9.5 12.4998L14 7.99982" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                        </svg>

                        <p>100% money-back guarantee</p>
                    </div> */}
                    <div className="price-cancel-item">
                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50263 20C12.3069 18.427 16.5 14.7524 16.5 10.4645C16.5 4.74981 16.5 2.70721 16.5 2.70721L8.50263 0L0.5 2.70978C0.5 2.70978 0.5 4.75237 0.5 10.467C0.5 14.7524 4.70099 18.427 8.50263 20Z" fill="black" />
                            <path d="M5 9.5L7.5 12L12 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        <p>No commitments. Cancel anytime.</p>
                    </div>
                </div>
            </div>



        </div>
    );
}

export default Price9;
